export type PickedContact = {
  name: string
  tel: string
  digits: string
}

type ContactsManagerLike = {
  getProperties: () => Promise<string[]>
  select: (
    properties: string[],
    options?: { multiple?: boolean },
  ) => Promise<Array<{ name?: string[]; tel?: string[] }>>
}

function contactsApi(): ContactsManagerLike | null {
  if (typeof navigator === 'undefined') return null
  const api = (navigator as Navigator & { contacts?: ContactsManagerLike }).contacts
  return api && typeof api.select === 'function' ? api : null
}

/** Contact Picker (Chrome/Android, HTTPS). Sem persistência — só o que o usuário escolhe. */
export function isContactPickerSupported(): boolean {
  return contactsApi() !== null
}

export function digitsFromTel(raw: string): string {
  let d = raw.replace(/\D/g, '')
  if (d.startsWith('00')) d = d.slice(2)
  // BR celular 11 dígitos (DDD+9…) → prefixa 55
  if (d.length === 10 || d.length === 11) {
    d = '55' + d
  }
  return d
}

export function whatsappInviteUrl(digits: string, message: string): string {
  const text = encodeURIComponent(message)
  return digits ? `https://wa.me/${digits}?text=${text}` : `https://wa.me/?text=${text}`
}

export async function pickContacts(multiple = true): Promise<PickedContact[]> {
  const api = contactsApi()
  if (!api) {
    throw new Error('Seu navegador não oferece a agenda. Use Chrome no Android (HTTPS).')
  }

  const supported = await api.getProperties()
  const props = ['name', 'tel'].filter((p) => supported.includes(p))
  if (!props.includes('tel')) {
    throw new Error('Este aparelho não compartilha telefone pela agenda.')
  }

  const rows = await api.select(props, { multiple })
  const out: PickedContact[] = []
  for (const row of rows) {
    const name = (row.name?.[0] || 'Contato').trim()
    for (const tel of row.tel ?? []) {
      const digits = digitsFromTel(tel)
      if (digits.length < 10) continue
      out.push({ name, tel: tel.trim(), digits })
    }
  }
  return out
}
